import React from 'react';

interface AIGenerationCardProps {
    children?: React.ReactNode;
}

function AIGenerationCard({children}: AIGenerationCardProps): JSX.Element {
    return <div className="c-aiGenerationCard">{children}</div>;
}

export default AIGenerationCard;
